var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgExit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M2.39404 9.03154V15.4774C2.39404 15.9415 2.80537 16.3177 3.31514 16.3177H7.91709C8.4251 16.3177 8.83818 15.9415 8.83818 15.4774C8.83818 15.0134 8.42686 14.6372 7.91709 14.6372H4.23623V3.42412H7.91885C8.42686 3.42412 8.83994 3.04795 8.83994 2.58389C8.83994 2.11982 8.42861 1.74365 7.91885 1.74365H3.31514C2.80713 1.74365 2.39404 2.11982 2.39404 2.58389V9.03154ZM15.7095 8.42334C15.887 8.57803 15.9978 8.80127 15.9978 9.04912C15.9978 9.29873 15.887 9.52022 15.7095 9.6749L12.8021 12.1956C12.6474 12.3292 12.4417 12.4118 12.2185 12.4118C11.7368 12.4118 11.3466 12.0339 11.3466 11.5698C11.3466 11.322 11.4591 11.0987 11.6366 10.9458L12.8548 9.88935H7.56377C7.08213 9.88935 6.6919 9.51318 6.6919 9.04912C6.6919 8.58506 7.08213 8.20889 7.56377 8.20889H12.8513L11.6331 7.15244C11.4556 6.99951 11.3431 6.77451 11.3431 6.52666C11.3431 6.0626 11.7351 5.68643 12.2149 5.68643C12.4399 5.68643 12.6438 5.76728 12.7985 5.90264L15.7095 8.42334Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExit);
export default __webpack_public_path__ + "static/media/exit.e0f487d82e0d8fd19198e42626361dd1.svg";
export { ForwardRef as ReactComponent };